// extracted by mini-css-extract-plugin
module.exports = {"container":"_3zeiYXHsHfdpORE7kQYtbj","icon-box":"_63t0irOFtXdqUG_NDQgLV","icon":"_2bQoKxsjhvftzBS5_90NQb","btns":"_1WOW7ADmt5Lpet-vMnAkY4"};